const STORAGE_KEY = 'hsl_pending_verify_email';

export function savePendingVerifyEmail(email: string): void {
  sessionStorage.setItem(STORAGE_KEY, email.trim().toLowerCase());
}

export function loadPendingVerifyEmail(): string {
  return sessionStorage.getItem(STORAGE_KEY) ?? '';
}

export function clearPendingVerifyEmail(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

/** Login 401 — e-posta henüz doğrulanmamış */
export function isUnverifiedEmailLoginError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const msg = error.message.toLowerCase();
  return msg.includes('doğrul') || msg.includes('dogrul');
}

/** Doğrulama token'ının süresi dolmuş */
export function isExpiredVerificationTokenError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const msg = error.message.toLowerCase();
  return msg.includes('süresi dolmuş') || msg.includes('suresi dolmus');
}
